import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { QnSbnService } from '../services/qn-sbn-service.service';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { OneWebComponentsAngularModule } from '@one/angular';
import { CommonModule } from '@angular/common';
import { SnackbarService } from '../services/snackbar.service';

@Component({
  selector: 'dl-email-delivery-details',
  standalone: true,
  imports: [OneWebComponentsAngularModule, CommonModule],
  templateUrl: './email-delivery-details.component.html',
  styleUrls: ['./email-delivery-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EmailDeliveryDetailsComponent implements OnChanges {

  dataFetch: any;
  emailResponse: any;
  @Input() emailData: any;
  @Output() closeDialog = new EventEmitter<any>();

  constructor(
    private snackBarNotification: SnackbarService,
    public qnsbnService: QnSbnService,
    public changeDetectorRef: ChangeDetectorRef,
  ){}



   ngOnChanges(changes: SimpleChanges): void {

    if (changes['emailData'] && changes['emailData'].currentValue) {
      console.log('Email data changed:', changes['emailData'].currentValue);
      this.qnsbnService.emailReportDetails(this.emailData).subscribe(
        res => {
          this.dataFetch = res;
          this.emailResponse = this.dataFetch.emailResponseData;
           this.changeDetectorRef.detectChanges();
        },
        err => {
          this.snackBarNotification.snackBarMessage('alarm', 'Please try again later');
          
        }
      )
    }
  }

  close() {
    this.closeDialog.emit({ action: 'close' });
  }

}
